import _ from "lodash";
import initialObjectStructure from "../FormModel/InitialObjectStructure.json";
import { WidgetEnum } from "../Store/WidgetEnum";

function ApplicationDataHelper() {
  /**
   * fill esign in date to holder object
   * @param {object} workflowData 
   * @param {object} holderData 
   * @returns 
   */
   function fillDigitalVerificationDetails(workflowData, holderData) {
    var digitalSignVerificationDTO =
      initialObjectStructure.digitalSignVerificationDTO;
    let digitalSignVerificationDetailsWidget = _.find(
      workflowData?.widgetDTOList ?? [],
      (widget) => widget.widgetShortName === WidgetEnum.ESIGNTC
    );

    //check person details widget data exists
    if (
      digitalSignVerificationDetailsWidget &&
      digitalSignVerificationDetailsWidget.widgetShortName ===  WidgetEnum.ESIGNTC
    ) {
      if (!_.isEmpty(digitalSignVerificationDetailsWidget.widgetDataJson)) {
        digitalSignVerificationDTO = JSON.parse(
          digitalSignVerificationDetailsWidget.widgetDataJson
        );
      }
    }
    holderData = {
      ...holderData,
      digitalSignVerificationDTO: digitalSignVerificationDTO,
    };
    return holderData;
  }

     
  function fillBankVerification(workflowData, holderData) {
    var bankAccountVerificationDTO =
      initialObjectStructure.bankAccountVerificationDTO;
    let bankVerificationDetailsWidget = _.find(
      workflowData?.widgetDTOList ?? [],
      (widget) => widget.widgetShortName ===  WidgetEnum.BANKVF
    );

    //check person details widget data exists
    if (
      bankVerificationDetailsWidget &&
      bankVerificationDetailsWidget.widgetShortName === WidgetEnum.BANKVF
    ) {
      if (!_.isEmpty(bankVerificationDetailsWidget.widgetDataJson)) {
        bankAccountVerificationDTO = JSON.parse(
          bankVerificationDetailsWidget.widgetDataJson
        );
      }
    }
    holderData = {
      ...holderData,
      bankAccountVerificationDTO: bankAccountVerificationDTO,
    };
    return holderData;
  }
    
    function fillNomineeDetails(workflowData, holderData) {
    var nomineeWidgetDTO = initialObjectStructure.nomineeWidgetDTO;
    let nomineeDetailsWidget = _.find(
      workflowData?.widgetDTOList ?? [],
      (widget) => widget.widgetShortName === WidgetEnum.NOMINEE
    );
    //check person details widget data exists
    if (
      nomineeDetailsWidget &&
      nomineeDetailsWidget.widgetShortName === WidgetEnum.NOMINEE
    ) {
      if (!_.isEmpty(nomineeDetailsWidget.widgetDataJson)) {
        nomineeWidgetDTO = JSON.parse(nomineeDetailsWidget.widgetDataJson);
      }
    }

    //set nominee widget dto in holder data
    holderData = { ...holderData, nomineeWidgetDTO: nomineeWidgetDTO };

    return holderData;
  }

  function fillVideoKycDetails(workflowData, holderData) {
    var videoKycDTO = initialObjectStructure.videoKycDTO;

    let videoKycDetailsWidget = _.find(
      workflowData?.widgetDTOList ?? [],
      (widget) => widget.widgetShortName === WidgetEnum.VIDEOKYC
    );

    //check data exists
    if (
      videoKycDetailsWidget &&
      videoKycDetailsWidget.widgetShortName === WidgetEnum.VIDEOKYC
    ) {
      if (!_.isEmpty(videoKycDetailsWidget.widgetDataJson)) {
        videoKycDTO = JSON.parse(videoKycDetailsWidget.widgetDataJson);
      }
    }
    holderData = {
      ...holderData,
      videoKycDTO: videoKycDTO,
    };
    return holderData;
  }
  /** fill PersonalDetailsWidget */
  function fillPersonalDetails(workflowData, holderData) {
    var personalInfoDTO = initialObjectStructure.personalInfoDTO;
    let PersonalDetailsWidget = _.find(
      workflowData?.widgetDTOList ?? [],
      (widget) => widget.widgetShortName === WidgetEnum.PERSONALINFO
    );
    //check person details widget data exists
    if (
      PersonalDetailsWidget &&
      PersonalDetailsWidget.widgetShortName === WidgetEnum.PERSONALINFO
    ) {
      if (!_.isEmpty(PersonalDetailsWidget.widgetDataJson)) {
        personalInfoDTO = JSON.parse(PersonalDetailsWidget.widgetDataJson);
      }
    }

    holderData = {
      ...holderData,
      personalInfoDTO: personalInfoDTO,
    };
    return holderData;
  }

  /** Construct Holder data */
  const constructHolderData = (data, holderType) => {
    //filter the first holder data
    let holderObject = _.find(
      data.kycApplicationEntityDTOList,
      (holder) => holder.entityTypeShortName === holderType
    );
    let holderData = {};
    //check object empty
    if (holderObject && holderObject.entityTypeShortName === holderType) {
      //filter the workflow data
      let workflowData = _.find(
        holderObject.kycApplicationWorkflowDTOList,
        (workflow) =>
          workflow.workflowDisplayName ===
          holderObject.selectedWorkflowDisplayName
      );
      if(workflowData!=null){
      //filter personal detail widget data
      holderData = fillPersonalDetails(workflowData, holderData);
      //filter Nominee detail widget data
      holderData = fillNomineeDetails(workflowData, holderData);
      //filter Bank verification widget data
      holderData = fillBankVerification(workflowData, holderData);
      //filter digital sigining verifcation details widget data
      holderData = fillDigitalVerificationDetails(workflowData, holderData);
      //filter video kyc data
      holderData = fillVideoKycDetails(workflowData, holderData);
      }else{
        //do nothing
      }
      
    }
    return holderData;
  };

  /** get Widget dto list for the holder */
  const getWidgetDTOList = (data, holderType) => {
    let holderObject = _.find(
      data.kycApplicationEntityDTOList,
      (holder) => holder.entityTypeShortName === holderType
    );

    let widgetDTOList = [];
    //check object empty
    if (holderObject) {
      //filter the workflow data
      let workflowData = _.find(
        holderObject.kycApplicationWorkflowDTOList,
        (workflow) =>
          workflow.workflowDisplayName ===
          holderObject.selectedWorkflowDisplayName
      );
      widgetDTOList = workflowData?.widgetDTOList ?? [];
    }
    return widgetDTOList;
  };


  const updateHolderData = (holderData, widgetDTO) => {
    var widgetDataDTO = JSON.parse(widgetDTO.widgetDataJson);

    switch (widgetDTO.widgetShortName) {
      case WidgetEnum.PERSONALINFO:
        holderData = {
          ...holderData,
          personalInfoDTO: widgetDataDTO,
        };
        break;
      case WidgetEnum.NOMINEE:
        holderData = {
          ...holderData,
          nomineeWidgetDTO: widgetDataDTO,
        };
        break;
      case WidgetEnum.BANKVF:
        holderData = {
          ...holderData,
          bankAccountVerificationDTO: widgetDataDTO,
        };
        break;

      default:
        break;
    }

    return holderData;
  };

  return {constructHolderData, getWidgetDTOList, updateHolderData};
}

export default ApplicationDataHelper;
